export default __webpack_public_path__ + "static/media/use-case-block-2.fa631060.png";